// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MimaCheckout_main__4dBcF {
  background-color: var(--color-white);
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  box-sizing: border-box;
  padding: 5rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaCheckout_main__4dBcF {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.MimaCheckout_bizInfo__ASEkH {
  display: flex;
  justify-content: space-between;
  text-align: right;
}
@media only screen and (max-width: 31.25em) {
  .MimaCheckout_bizInfo__ASEkH {
    flex-direction: column;
    align-items: center;
    margin-bottom: 3rem;
    text-align: center;
  }
  .MimaCheckout_bizInfo__ASEkH > :not(:last-child) {
    margin-bottom: 1rem;
  }
}
.MimaCheckout_bizInfo__ASEkH img {
  height: 4.7rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaCheckout_bizInfo__ASEkH img {
    width: 22rem;
    height: auto;
  }
}

.MimaCheckout_payInfo__QFi01 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}
.MimaCheckout_payInfo__main__yl72D {
  padding: 2rem;
  border: 1px solid var(--color-primary);
  width: 55rem;
  border-radius: 2rem;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaCheckout_payInfo__main__yl72D {
    width: 40rem;
  }
}
.MimaCheckout_payInfo__main_one__pDCCH {
  grid-column: 1/3;
  padding: 3rem 0;
}
.MimaCheckout_payInfo__main_text__2zqPA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.MimaCheckout_payInfo__main_text2__ofAo5 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.MimaCheckout_payInfo__main_text2__grid__0YR2v {
  display: grid;
  grid-template-columns: 1fr 4rem;
  gap: 1rem;
  width: 100%;
  align-items: center;
  margin-bottom: 3rem;
}
.MimaCheckout_payInfo__main_text2__grid__0YR2v > :last-child {
  color: var(--color-dark);
  transition: all 1s;
  cursor: pointer;
  font-size: 2rem;
}
.MimaCheckout_payInfo__main_text2__grid__0YR2v > :last-child:hover {
  color: var(--color-primary);
}
.MimaCheckout_payInfo__info__VpAeh {
  padding: 2rem;
  width: 55rem;
  border-radius: 2rem;
  background-color: var(--color-primary-3);
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaCheckout_payInfo__info__VpAeh {
    width: 40rem;
  }
}
.MimaCheckout_payInfo__info__VpAeh > :first-child {
  font-size: 3rem;
}
.MimaCheckout_payInfo__info2__39LGX {
  padding: 1rem;
  width: 100%;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
  align-items: center;
}
.MimaCheckout_payInfo__info2__39LGX > :first-child {
  width: 3rem;
}
.MimaCheckout_payInfo__nav__Fn3UT {
  background-color: var(--color-table-grey-1);
  border-radius: 1rem;
  box-sizing: border-box;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: fit-content;
}
.MimaCheckout_payInfo__nav__Fn3UT > :not(:last-child) {
  margin-bottom: 1rem;
}
.MimaCheckout_payInfo__nav_item__WiXBy {
  font-size: var(--default-font-small);
  padding: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.MimaCheckout_payInfo__nav_item__WiXBy img {
  width: 3rem;
}
.MimaCheckout_payInfo__nav_active__8u-yC {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
  border-radius: 1rem;
}

.MimaCheckout_span__s1rrr,
.MimaCheckout_a__zJn8N {
  color: var(--color-primary);
  font-weight: 700;
}

.MimaCheckout_successImg__1czE- {
  width: 50rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .MimaCheckout_successImg__1czE- {
    width: 38rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/MimaCheckout/MimaCheckout.module.scss"],"names":[],"mappings":"AAEA;EACC,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;AADD;AAGC;EARD;IASE,aAAA;IACA,sBAAA;IACA,uBAAA;EAAA;AACF;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,iBAAA;AAAD;AAEC;EALD;IAME,sBAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EACA;EACA;IACC,mBAAA;EACD;AACF;AAEC;EACC,cAAA;AAAF;AAGE;EAJD;IAKE,YAAA;IACA,YAAA;EAAD;AACF;;AAMA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAHD;AAKC;EACC,aAAA;EACA,sCAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sCAAA;EACA,SAAA;AAHF;AAKE;EATD;IAUE,YAAA;EAFD;AACF;AAIE;EACC,gBAAA;EACA,eAAA;AAFH;AAKE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAHH;AAME;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAJH;AAMG;EACC,aAAA;EACA,+BAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;AAMI;EACC,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAJL;AAMK;EACC,2BAAA;AAJN;AAWC;EACC,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;AATF;AAYE;EAXD;IAYE,YAAA;EATD;AACF;AAWE;EACC,eAAA;AATH;AAaC;EACC,aAAA;EACA,WAAA;EACA,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAXF;AAaE;EACC,WAAA;AAXH;AAgBC;EACC,2CAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAdF;AAgBE;EACC,mBAAA;AAdH;AAiBE;EACC,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAfH;AAiBG;EACC,WAAA;AAfJ;AAmBE;EACC,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAjBH;;AAsBA;;EAEC,2BAAA;EACA,gBAAA;AAnBD;;AAsBA;EACC,YAAA;EACA,mBAAA;AAnBD;AAqBC;EAJD;IAKE,YAAA;EAlBA;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tbackground-color: var(--color-white);\n\twidth: 100vw;\n\tmin-height: 100vh;\n\theight: 100%;\n\tbox-sizing: border-box;\n\tpadding: 5rem;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t}\n}\n\n.bizInfo {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\ttext-align: right;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tmargin-bottom: 3rem;\n\t\ttext-align: center;\n\n\t\t&>:not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\n\timg {\n\t\theight: 4.7rem;\n\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\twidth: 22rem;\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\n}\n\n.payInfo {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmargin-top: 2rem;\n\n\t&__main {\n\t\tpadding: 2rem;\n\t\tborder: 1px solid var(--color-primary);\n\t\twidth: 55rem;\n\t\tborder-radius: 2rem;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: max-content 1fr;\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\twidth: 40rem;\n\t\t}\n\n\t\t&_one {\n\t\t\tgrid-column: 1/3;\n\t\t\tpadding: 3rem 0;\n\t\t}\n\n\t\t&_text {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t&_text2 {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\n\t\t\t&__grid {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 1fr 4rem;\n\t\t\t\tgap: 1rem;\n\t\t\t\twidth: 100%;\n\t\t\t\talign-items: center;\n\t\t\t\tmargin-bottom: 3rem;\n\n\t\t\t\t&> :last-child {\n\t\t\t\t\tcolor: var(--color-dark);\n\t\t\t\t\ttransition: all 1s;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tfont-size: 2rem;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&__info {\n\t\tpadding: 2rem;\n\t\twidth: 55rem;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tdisplay: grid;\n\t\tgrid-template-columns: max-content 1fr;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 2rem;\n\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\twidth: 40rem;\n\t\t}\n\n\t\t&> :first-child {\n\t\t\tfont-size: 3rem;\n\t\t}\n\t}\n\n\t&__info2 {\n\t\tpadding: 1rem;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: max-content 1fr;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 2rem;\n\t\tfont-size: 1.4rem;\n\t\talign-items: center;\n\n\t\t&> :first-child {\n\t\t\twidth: 3rem;\n\t\t}\n\t}\n\n\n\t&__nav {\n\t\tbackground-color: var(--color-table-grey-1);\n\t\tborder-radius: 1rem;\n\t\tbox-sizing: border-box;\n\t\tpadding: 1rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: fit-content;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&_item {\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tpadding: 1rem;\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 1rem;\n\n\t\t\timg {\n\t\t\t\twidth: 3rem;\n\t\t\t}\n\t\t}\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-weight: 700;\n\t\t\tborder-radius: 1rem;\n\t\t}\n\t}\n}\n\n.span,\n.a {\n\tcolor: var(--color-primary);\n\tfont-weight: 700;\n}\n\n.successImg {\n\twidth: 50rem;\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\twidth: 38rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `MimaCheckout_main__4dBcF`,
	"bizInfo": `MimaCheckout_bizInfo__ASEkH`,
	"payInfo": `MimaCheckout_payInfo__QFi01`,
	"payInfo__main": `MimaCheckout_payInfo__main__yl72D`,
	"payInfo__main_one": `MimaCheckout_payInfo__main_one__pDCCH`,
	"payInfo__main_text": `MimaCheckout_payInfo__main_text__2zqPA`,
	"payInfo__main_text2": `MimaCheckout_payInfo__main_text2__ofAo5`,
	"payInfo__main_text2__grid": `MimaCheckout_payInfo__main_text2__grid__0YR2v`,
	"payInfo__info": `MimaCheckout_payInfo__info__VpAeh`,
	"payInfo__info2": `MimaCheckout_payInfo__info2__39LGX`,
	"payInfo__nav": `MimaCheckout_payInfo__nav__Fn3UT`,
	"payInfo__nav_item": `MimaCheckout_payInfo__nav_item__WiXBy`,
	"payInfo__nav_active": `MimaCheckout_payInfo__nav_active__8u-yC`,
	"span": `MimaCheckout_span__s1rrr`,
	"a": `MimaCheckout_a__zJn8N`,
	"successImg": `MimaCheckout_successImg__1czE-`
};
export default ___CSS_LOADER_EXPORT___;
